export namespace CustomFields {
  export interface Field {
    field_id: number;
    name: string;
    label: string;
    type_id: number;
    is_required: boolean;
    professional_read_only: boolean;
    default_value: string;
    status_id: number;
    group_id: number | null;
    is_mapped: boolean;
    use_in_profile: boolean;
    use_in_list: boolean;
    is_encrypted: boolean;
    is_encrypting_enabled: boolean;
  }

  export interface FieldInstance extends Field {
    value_id: number;
    value: Attachment[] | any;
  }

  export interface Group {
    group_id: number;
    name: string;
    fields?: Field[];
  }

  export interface GroupInstance extends Group {
    fields: FieldInstance[];
  }

  export interface Attachment {
    name: string;
    size: number;
    url: string;
    id: number;
  }

  export interface ReorderSchema {
    who: {
      with_group: boolean;
      item_id: number;
    };
    where: {
      prev_item_id: number;
      group_id: number;
    };
  }

  export type Item = Field | Group;
  export type ItemInstance = FieldInstance | GroupInstance;
}

export interface OrganizationCustomField {
  default: string | null;
  display: string;
  group: number | null;
  id: number;
  name: string;
  type: number;
  isEncrypted: boolean;
}

export enum CUSTOM_MODAL_VIEW_MODE {
  FORM,
  ENCRYPTED_INFO,
}

export interface CustomFieldCreationParams {
  custField?: CustomFields.Field;
  custGroups?: CustomFields.Group[];
  createForOrganization?: number;
}

export interface CustomFieldPolicyPermission {
  addField: boolean;
  addFieldGroup: boolean;
  editField: boolean;
  deleteField: boolean;
  editGroup: boolean;
  deleteFieldGroup: boolean;
}
